// TODO: Add image alt tag.
/* eslint-disable jsx-a11y/alt-text */
import { PageComponent } from '@root/pages/Type';
import { Trans } from 'react-i18next';
import styles from './PricesSection.module.scss';

const PricesSection: PageComponent = () => {
    return (
        <section className={styles.section}>
            <div className={styles.background_diamonds_sides}>
                <div className={`container ${styles.container}`}>
                    <img
                        src="/static/img/control-panel-background.svg"
                        className={styles.before}
                    />
                    <div className={styles.phone}>
                        <a href="tel:+37067174997">
                            <img src="/static/img/icons/phone.svg" />
                            +370 671 74997
                        </a>
                    </div>
                    <div className={styles.colocation_inner_container}>
                        <div className={styles.colocation_inner}>
                            <div>
                                <Trans
                                    i18nKey="priceText"
                                    ns="landingServicesColocation"
                                >
                                    nuo
                                    <span>79 EUR</span>
                                    <span className={styles.small}>/men</span>
                                </Trans>
                            </div>
                        </div>
                    </div>
                    <div className={styles.email}>
                        <a href="mailto:info@vpsnet.lt">
                            <img src="/static/img/icons/email.svg" />
                            info@vpsnet.lt
                        </a>
                    </div>
                    <img
                        src="/static/img/control-panel-background.svg"
                        className={styles.after}
                    />
                </div>
            </div>
        </section>
    );
};

export default PricesSection;
